import { Box } from "@mui/material";
import SectionCollapsible from "../../../../common/SectionCollapsible";
import type { CollapsibleFormSectionProps } from "../../types";
import UniqueBenefitsInputs from ".";

function AssessmentUniqueBenefitsContainer({
  open,
}: CollapsibleFormSectionProps) {
  return (
    <Box data-testid="writeable-assessment-unique-benefits-table-container">
      <SectionCollapsible open={open} label="Assessment Unique Benefits Table">
        <UniqueBenefitsInputs />
      </SectionCollapsible>
    </Box>
  );
}

export default AssessmentUniqueBenefitsContainer;
